import React from "react";

const ManageLearner = ({ PageName, IconName }) => {
  const Color = PageName === IconName ? "#4C34AD" : "#fff";

  return (
    <div className="ml-0 flex items-center gap-4">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="31.065"
        height="31.065"
        viewBox="0 0 31.065 31.065"
      >
        <defs>
          <clipPath id="clip-path">
            <path id="Path_94237" d="M0-47.5H31.065v31.065H0Z" />
          </clipPath>
        </defs>
        <g
          transform="translate(0 47.5)"
          clipPath="url(#clip-path)"
        >
          <path
            d="M30.68-20.09a3.27,3.27,0,0,1-3.27,3.27H4.52a3.27,3.27,0,0,1-3.27-3.27V-42.98a3.27,3.27,0,0,1,3.27-3.27H27.41a3.27,3.27,0,0,1,3.27,3.27Z"
            transform="translate(-0.433 -0.433)"
            fill="#feffff"
          />
          <path
            d="M17.241-35.851a1.817,1.817,0,0,1,1.9-1.977,1.817,1.817,0,0,1,1.9,1.977v12.724h4.513A1.723,1.723,0,0,1,27.381-21.3a1.777,1.777,0,0,1-1.825,1.673H19.218a1.879,1.879,0,0,1-1.977-2.079V-35.851Z"
            transform="translate(-5.965 -3.347)"
            fill="#4f37af"
          />
        </g>
      </svg>

      <p className="font-bold text-white">Manage Learner</p>
    </div>
  );
};

export default ManageLearner;
